export enum DaysOfWeekEnum {
    sunday = 64,
    monday = 1,
    tuesday = 2,
    wednesday = 4,
    thursday = 8,
    friday = 16,
    Saturday = 32
}
export enum RecurringTypesEnum {
    none = 0,
    daily = 1,
    weekly = 2,
    monthly = 3
}
export enum CalenderViewEnum {
    day = 1,
    week = 2,
    month = 3
}
